import { render, staticRenderFns } from "./MyProduct.vue?vue&type=template&id=2a7a5b46&scoped=true"
import script from "./MyProduct.vue?vue&type=script&lang=js"
export * from "./MyProduct.vue?vue&type=script&lang=js"
import style0 from "./MyProduct.vue?vue&type=style&index=0&id=2a7a5b46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7a5b46",
  null
  
)

export default component.exports